<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="d-flex justify-content-between mt-0">
        <h5 class="card-title">Review New Instructors</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-auto-md-12 ">
        <ul class="list-group list-group-flush" *ngIf="unApprovedAsInstructors?.length>0">
          <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let user of unApprovedAsInstructors">
            <span ><a href="/profile/{{user.userId}}" class="name">{{user.firstName}} {{user.lastName}}</a></span>
            <span *ngIf="user.rejectedAsInstructor" class="red">Rejected</span>
            <span *ngIf="!user.rejectedAsInstructor || updatingStatus">
              <button mat-stroked-button color="primary" class="me-2" (click)="approveInstructor(user)">Approve</button>
              <button mat-stroked-button color="primary" (click)="rejectInstructor(user)">Reject</button>
            </span>
            <span *ngIf="user.rejectedAsInstructor && !updatingStatus">
              <button mat-stroked-button color="primary" (click)="updateInstructorStatus()">Update Status</button>
            </span>
          </li>
        </ul>
        <p *ngIf="unApprovedAsInstructors?.length<=0">
          No new instructors are available to review
        </p>
      </div>
    </div>
  </div>
</div>
